<template>
  <div class="asset-picker-component">
    <div v-if="isVehicleOnMap && !search">
      <AssetIcon class="item" @click.native="setAllVehiclesAsActive()" />
    </div>
    <div class="asset-slider">
      <button
          @click="previousSlide"
          :class="{ active: assetSlider.isPreviousSlideNavActive }"
          v-if="showSliderNav"
      >
        <svg width="28" height="28" viewBox="0 0 28 28">
          <circle class="btn-circle" cx="14" cy="14" r="12.5" />
          <path
              class="btn-arrow"
              d="M16.354,20.354a.5.5,0,0,1-.708,0L9.646,14.354a.5.5,0,0,1,0-.708l6-6a.5.5,0,0,1,.708.708L10.707,14l5.647,5.646A.5.5,0,0,1,16.354,20.354Z"
          />
        </svg>
      </button>
      <div
          class="slide"
          v-for="(asset, index) in filteredAssets"
          :key="asset.SafeAndSoundVehicleId"
          :data-id="index"
          v-show="isSlideVisible(index)"
      >
        <AssetIcon
          class="item"
          :vehicleId="asset.SafeAndSoundVehicleId"
          :registrationNumber="asset.RegistrationNumber"
          :active="
            asset.show ||
              ((isFeatureViewer(asset.ProductName) || asset.hasAccuracyRing) &&
                isSelected(asset.SafeAndSoundVehicleId))
          "
          :isMarker="false"
          :isFeatureViewer="
            asset.IsInRecovery || asset.hasAccuracyRing || isFeatureViewer(asset.ProductName)
          "
          :isAssetPicker="true"
          :hideFeatureViewer="hideFeatureViewer"
          :sendToBack="
            activeFeatureViewerVehicleId &&
              asset.SafeAndSoundVehicleId != activeFeatureViewerVehicleId
          "
          :starTag="asset.ProductDisplayName === 'StarTag'"
          :hasAccuracyRing="asset.hasAccuracyRing"
          @featureViewerInfoOpen="handleFeatureViewerIsOpen"
          @click.native="activate(asset)"
        />
      </div>
      <button
          @click="nextSlide"
          :class="{ active: assetSlider.isNextSlideNavActive }"
          v-if="showSliderNav"
      >
        <svg width="28" height="28" viewBox="0 0 28 28">
          <circle class="btn-circle" cx="14" cy="14" r="12.5" />
          <path
              class="btn-arrow"
              d="M11.646,7.646a.5.5,0,0,1,.708,0l6,6a.5.5,0,0,1,0,.708l-6,6a.5.5,0,0,1-.708-.708L17.293,14,11.646,8.354A.5.5,0,0,1,11.646,7.646Z"
          />
        </svg>
      </button>
    </div>
    <div class="search-box" v-if="showSearchBox">
      <svg xmlns="http://www.w3.org/2000/svg" width="26.604" height="21.228" viewBox="0 0 26.604 21.228">
        <g id="Group_3822" data-name="Group 3822" transform="translate(6703.38 96.028)">
          <g id="Group_2317" data-name="Group 2317" transform="translate(-6702.979 -95.475)">
            <g id="Group_2077" data-name="Group 2077">
              <g id="Group_2061" data-name="Group 2061">
                <path id="Path_867" data-name="Path 867" d="M-9274.015,2306.047a3.1,3.1,0,0,1-2.011-.672,2.276,2.276,0,0,1-.787-1.864c0-.259-.018-2.763,0-3.969a2.9,2.9,0,0,1,.785-2.114h0s.734-.66,1.958-1.763a4.376,4.376,0,0,0,1.316-1.728l.006-.025.009-.019c.006-.015.61-1.528,1.4-3.646.687-1.85,1.756-2.122,1.94-2.156a7.616,7.616,0,0,1,.972-.148h.024a.4.4,0,0,1,.4.375.4.4,0,0,1-.375.424,7.082,7.082,0,0,0-.857.133l-.023,0c-.085.021-.807.235-1.33,1.646-.742,2-1.324,3.463-1.4,3.646a5.023,5.023,0,0,1-1.546,2.088c-1.224,1.1-1.958,1.764-1.958,1.764l0,0a2.137,2.137,0,0,0-.516,1.527c-.019,1.258,0,3.946,0,3.973v.029l0,.029a1.463,1.463,0,0,0,.521,1.191,2.33,2.33,0,0,0,1.486.47c.1,0,.163-.005.165-.006l.041,0h10.181a.4.4,0,0,1,.4.4.4.4,0,0,1-.4.4h-10.163C-9273.822,2306.042-9273.9,2306.047-9274.015,2306.047Z" transform="translate(9276.42 -2288.309)" fill="#140047"/>
                <path id="Path_868" data-name="Path 868" d="M-9266.028,2306.027c-.111,0-.192-.005-.23-.008h-10.163a.4.4,0,0,1-.4-.4.4.4,0,0,1,.4-.4l10.222,0a2.461,2.461,0,0,0,1.651-.464,1.48,1.48,0,0,0,.522-1.192l0-.029v-.029c0-.027.019-2.716,0-3.973a2.139,2.139,0,0,0-.516-1.526l-.006,0h0s-.734-.66-1.958-1.764a5.028,5.028,0,0,1-1.546-2.088c-.073-.183-.654-1.646-1.4-3.646-.529-1.423-1.259-1.629-1.333-1.646l-.024,0-.009,0a7.376,7.376,0,0,0-.876-.164.4.4,0,0,1-.363-.434.4.4,0,0,1,.4-.365h.035a7.926,7.926,0,0,1,.987.182c.2.039,1.255.326,1.935,2.154.787,2.119,1.391,3.632,1.4,3.647l.01.023.006.025a4.4,4.4,0,0,0,1.315,1.724c1.224,1.1,1.958,1.763,1.958,1.763h0a2.9,2.9,0,0,1,.786,2.114c.018,1.206,0,3.711,0,3.969a2.282,2.282,0,0,1-.788,1.864A3.1,3.1,0,0,1-9266.028,2306.027Z" transform="translate(9289.426 -2288.289)" fill="#140047"/>
                <path id="Path_869" data-name="Path 869" d="M-9254.007,2299.183h-15.377a.4.4,0,0,1-.4-.4.4.4,0,0,1,.4-.4h15.377a.4.4,0,0,1,.4.4A.4.4,0,0,1-9254.007,2299.183Z" transform="translate(9274.479 -2291.968)" fill="#140047"/>
                <path id="Path_870" data-name="Path 870" d="M-9247.161,2306.869c-.475,0-.633-.209-.683-.384-.029-.1-.087-.315.329-.867l1.194-1.736h3.924a.667.667,0,0,1,.572.311,1.382,1.382,0,0,1-.146,1.274,2.606,2.606,0,0,1-1.928,1.4l-.045,0h-3.084C-9247.054,2306.866-9247.1,2306.869-9247.161,2306.869Zm.311-.8h2.88a1.8,1.8,0,0,0,1.283-.954,1.748,1.748,0,0,0,.162-.428h-3.375Z" transform="translate(9266.199 -2293.793)" fill="#140047"/>
                <path id="Path_871" data-name="Path 871" d="M-9242.416,2306.869c-.058,0-.107,0-.134,0l-3.129,0a2.606,2.606,0,0,1-1.928-1.4,1.382,1.382,0,0,1-.146-1.274.667.667,0,0,1,.572-.311h3.923l1.2,1.736c.414.549.355.77.329.865C-9241.782,2306.66-9241.94,2306.869-9242.416,2306.869Zm-3.19-.8h2.88l-.951-1.382h-3.374a1.748,1.748,0,0,0,.162.428A1.794,1.794,0,0,0-9245.606,2306.065Z" transform="translate(9249.293 -2293.793)" fill="#140047"/>
                <path id="Path_872" data-name="Path 872" d="M-9263.768,2304.033h9.263a.65.65,0,0,1,.5.185.587.587,0,0,1,.072.631l-.016.038-.023.034-1.106,1.584a1.075,1.075,0,0,1-.365.364,1.273,1.273,0,0,1-.521.144h-6.551a1.291,1.291,0,0,1-.528-.144,1,1,0,0,1-.363-.384l-.972-1.616a.563.563,0,0,1,.085-.671A.73.73,0,0,1-9263.768,2304.033Zm8.884.8h-8.579l.767,1.276a.229.229,0,0,0,.057.065.535.535,0,0,0,.161.038H-9256a.488.488,0,0,0,.156-.038.289.289,0,0,0,.077-.08l.021-.035Z" transform="translate(9272.092 -2293.944)" fill="#140047"/>
                <path id="Path_873" data-name="Path 873" d="M-9272.04,2317.906l-.08,0h-2.375a1.568,1.568,0,0,1-1.175-.455,1.886,1.886,0,0,1-.473-1.274v-2.344h.8v2.362a1.109,1.109,0,0,0,.251.7.793.793,0,0,0,.6.208h2.418a1.063,1.063,0,0,0,.7-.229.916.916,0,0,0,.239-.7v-1.642h.8v1.642a1.671,1.671,0,0,1-.5,1.286A1.806,1.806,0,0,1-9272.04,2317.906Z" transform="translate(9276.185 -2297.232)" fill="#140047"/>
                <path id="Path_874" data-name="Path 874" d="M-9274.45,2317.859a1.789,1.789,0,0,1-1.193-.436,1.679,1.679,0,0,1-.5-1.289v-1.642h.8v1.642a.916.916,0,0,0,.243.7,1.046,1.046,0,0,0,.686.222h2.4a.777.777,0,0,0,.588-.208,1.129,1.129,0,0,0,.249-.7v-2.45h.8v2.433a1.89,1.89,0,0,1-.475,1.278,1.551,1.551,0,0,1-1.162.451h-2.353Z" transform="translate(9296.216 -2297.184)" fill="#140047"/>
                <path id="Path_875" data-name="Path 875" d="M-9265.814,2313.8l-.738-.306.639-1.541a.826.826,0,0,1,.7-.512c.241-.01,9.577,0,10.663,0h.013a.935.935,0,0,1,.851.5c.133.293.509,1.448.552,1.579l-.762.247c-.161-.5-.433-1.3-.518-1.5a.261.261,0,0,0-.121-.035h-.011c-3.5,0-10.117-.008-10.613,0-.01.011-.021.027-.022.029Z" transform="translate(9272.84 -2296.534)" fill="#140047"/>
                <path id="Path_876" data-name="Path 876" d="M-9274.95,2297.6a1.182,1.182,0,0,1-1.186-1.08,1.275,1.275,0,0,1,.621-1.389l.021-.013c.194-.123.521-.2,1.553-.2a3.782,3.782,0,0,1,1.441.154,2.145,2.145,0,0,1,.9.781l-.656.458a1.578,1.578,0,0,0-.479-.475,3.08,3.08,0,0,0-1.2-.117,4.014,4.014,0,0,0-1.132.079l-.041.024c-.12.07-.286.166-.229.593a.387.387,0,0,0,.388.385h2.338v.8h-2.333Z" transform="translate(9276.188 -2290.755)" fill="#140047"/>
                <path id="Path_877" data-name="Path 877" d="M-9272.333,2297.606h-2.332v-.8h2.328a.387.387,0,0,0,.4-.384c.056-.428-.109-.524-.23-.594l-.039-.024a4.027,4.027,0,0,0-1.134-.079,3.058,3.058,0,0,0-1.2.117,1.6,1.6,0,0,0-.48.475l-.656-.458a2.144,2.144,0,0,1,.895-.78,3.771,3.771,0,0,1,1.442-.154,3.143,3.143,0,0,1,1.552.2l.022.013a1.276,1.276,0,0,1,.622,1.389A1.183,1.183,0,0,1-9272.333,2297.606Z" transform="translate(9296.943 -2290.759)" fill="#140047"/>
                <path id="Path_881" data-name="Path 881" d="M-9335.623,2293.694a.4.4,0,0,1-.1-.013.4.4,0,0,1-.288-.487,26.442,26.442,0,0,1,.941-2.642.4.4,0,0,1,.522-.217.4.4,0,0,1,.216.522,26.523,26.523,0,0,0-.9,2.535A.4.4,0,0,1-9335.623,2293.694Z" transform="translate(9341.812 -2288.604)" fill="#140047"/>
              </g>
            </g>
          </g>
          <path id="Path_8593" data-name="Path 8593" d="M-5838.24,10826.962l-.046-.8c.033,0,3.322-.19,5.083-.19s4.786.148,4.816.15l-.039.8c-.03,0-3.038-.148-4.777-.148S-5838.207,10826.96-5838.24,10826.962Z" transform="translate(-856.806 -10922.001)" fill="#140047"/>
        </g>
      </svg>
      <input type="search" v-model="search" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.asset-picker-component {
  display: flex;
  align-items: center;
  position: absolute;
  top: 20px;
  left: 100px;
  z-index: 1;

  .asset-slider {
    display: flex;
    align-items: center;
    margin: 0 10px;

    .slide {
      margin: 0 5px;
    }

    button {
      background: transparent;
      padding: 0;
      margin: 0 8px;
      border-radius: 50%;
      border: none;

      &:focus {
        outline: none;
      }

      &:hover {
        cursor: inherit;
      }

      svg {
        margin: -3px;

        .btn-circle {
          fill: $brand-color-3;
        }

        .btn-arrow {
          fill: #fff;
        }
      }

      &.active {
        svg {
          .btn-circle {
            fill: $brand-color-2;
          }
        }

        &:hover {
          cursor: pointer;
        }
      }
    }
  }

  .search-box {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 8px 15px;
    border-radius: 20px;
    box-shadow: $drop-shadow;

    input[type="search"] {
      font-weight: 600;
      color: $brand-color-1;
      margin-left: 10px;
      border: none;

      &:focus {
        outline: none;
        border-bottom: 1px solid $brand-color-1;
      }
    }
  }
}

@media (max-width: 1250px) {
  .asset-picker-component {
    top: 50px;
  }
}

@media (max-width: $md) {
  .asset-picker-component {
    top: 80px;
    left: 15px;

    .search-box {
      position: absolute;
      top: 100px;
    }
  }
}
</style>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { assetService } from "@/services";
import AssetIcon from "@/components/AssetIcon";

export default {
  name: "AssetPicker",
  components: {
    AssetIcon,
  },
  data() {
    return {
      hideFeatureViewer: 0,
      activeFeatureViewerVehicleId: "",
      assetSlider: {
        firstSlideIndex: 0,
        slidesToShow: 5,
        isPreviousSlideNavActive: false,
        isNextSlideNavActive: true,
      },
      search: "",
    };
  },
  computed: {
    ...mapGetters("asset", ["getAllAssets", "getActiveSafeAndSoundVehicleId"]),
    filteredAssets() {
      return this.getAllAssets().filter(
        (asset) =>
          asset.RegistrationNumber &&
          !asset.shared &&
            ((asset.RegistrationNumber &&
                    asset.RegistrationNumber.toLowerCase().includes(
                        this.search.toLowerCase()
                    )) ||
                (asset.Nickname &&
                    asset.Nickname.toLowerCase().includes(this.search.toLowerCase())))
      );
    },
    assetsEligibleForDisplay() {
      return this.getAllAssets().filter(
          (asset) => asset.RegistrationNumber && !asset.shared
      );
    },
    isVehicleOnMap() {
      return this.filteredAssets.filter((obj) => "show" in obj).length;
    },
    showSliderNav() {
      return this.filteredAssets.length > this.assetSlider.slidesToShow;
    },
    showSearchBox() {
      return (
          this.assetsEligibleForDisplay.length > this.assetSlider.slidesToShow
      );
    },
  },
  methods: {
    ...mapActions("asset", ["setActiveAsset"]),
    ...mapActions("map", ["setMapBounds"]),
    ...mapMutations("asset", ["setMapActive"]),
    ...mapMutations("map", ["updateSelectedMarkerAssetId"]),
    isFeatureViewer(productName) {
      return !assetService.hasRealTimeLocationTracking(productName);
    },
    isSelected(assetId) {
      return assetId === this.getActiveSafeAndSoundVehicleId();
    },
    setAllVehiclesAsActive() {
      this.hideFeatureViewer++;
      this.setMapActive();
      this.setMapBounds();
    },
    handleFeatureViewerIsOpen(value) {
      this.activeFeatureViewerVehicleId = value.open ? value.vehicleId : "";
    },
    activate(asset) {
      if (asset.disabled) {
        return;
      }
      const currentSafeAndSoundVehicleId = this.getActiveSafeAndSoundVehicleId();
      this.setActiveAsset(asset.SafeAndSoundVehicleId);
      this.setMapActive(asset.SafeAndSoundVehicleId);
      if (
          currentSafeAndSoundVehicleId !== this.getActiveSafeAndSoundVehicleId()
      ) {
        this.setMapBounds();
      }
      if (!asset.hasAccuracyRing) {
        this.updateSelectedMarkerAssetId(null);
      }
    },
    isSlideVisible(index) {
      return (
          index >= this.assetSlider.firstSlideIndex &&
          index < this.assetSlider.firstSlideIndex + this.assetSlider.slidesToShow
      );
    },
    previousSlide() {
      if (this.assetSlider.firstSlideIndex !== 0) {
        this.assetSlider.firstSlideIndex -= 1;
        this.assetSlider.isPreviousSlideNavActive =
            this.assetSlider.firstSlideIndex !== 0;
        this.assetSlider.isNextSlideNavActive =
            this.assetSlider.firstSlideIndex !==
            this.filteredAssets.length - this.assetSlider.slidesToShow;
      }
    },
    nextSlide() {
      if (
          this.assetSlider.firstSlideIndex <
          this.filteredAssets.length - this.assetSlider.slidesToShow
      ) {
        this.assetSlider.firstSlideIndex += 1;
        this.assetSlider.isPreviousSlideNavActive =
            this.assetSlider.firstSlideIndex !== 0;
        this.assetSlider.isNextSlideNavActive =
            this.assetSlider.firstSlideIndex !==
            this.filteredAssets.length - this.assetSlider.slidesToShow;
      }
    },
  },
};
</script>
